// Programmatic SEO pages configuration
// This file defines all the content pages for PSEO

export const topicPages = [
  {
    slug: "how-to-play-do-or-drink",
    title: "How to Play Do or Drink - Complete Guide",
    description:
      "Learn how to play Do or Drink, the ultimate party game. Rules, setup, tips, and strategies for the perfect game night with friends or couples.",
    category: "guides",
    keywords: ["how to play", "rules", "guide", "instructions"],
    content: {
      intro:
        "Do or Drink is a classic party game that combines dares with drinking penalties. Whether you're playing with friends or your partner, the rules are simple: complete the dare or take a drink!",
      sections: [
        {
          heading: "Basic Rules",
          content:
            "The game is straightforward: one player reads a dare or challenge, and the player must either complete it or take a drink as a penalty. The game continues in turns, with challenges increasing in intensity.",
        },
        {
          heading: "Setting Up the Game",
          content:
            "Choose your game mode (BFF for friends, Date for couples, or Couples for intimate play), add player names, select the number of rounds, and start playing. No additional materials needed!",
        },
        {
          heading: "Tips for a Great Game",
          content:
            "Keep the dares fun and safe for everyone involved. Know your limits and respect boundaries. The best games happen when everyone is comfortable and having fun.",
        },
      ],
    },
    relatedModes: ["bff", "date", "couples"],
  },
  {
    slug: "party-games-for-groups",
    title: "Best Party Games for Large Groups | Muse Moment",
    description:
      "Discover the best party games for large groups and parties. From icebreakers to drinking games, find the perfect game for your next gathering.",
    category: "party-games",
    keywords: ["party games", "large groups", "group games", "gatherings"],
    content: {
      intro:
        "Hosting a large group? The right party game can make or break your event. Muse Moment's BFF mode supports up to 20 players, making it perfect for parties and gatherings.",
      sections: [
        {
          heading: "Why Group Games Matter",
          content:
            "Group games break the ice, create laughter, and help people connect. They turn awkward gatherings into memorable experiences filled with shared moments.",
        },
        {
          heading: "Choosing the Right Game",
          content:
            "Consider your group size, the occasion, and comfort levels. Muse Moment scales from intimate dates to large friend groups with progressive intensity that works for everyone.",
        },
        {
          heading: "Tips for Large Groups",
          content:
            "Keep games moving, ensure everyone participates, and have backup activities ready. With Muse Moment, the AI generates unique challenges so no two games are alike.",
        },
      ],
    },
    relatedModes: ["bff"],
  },
  {
    slug: "drinking-games-with-cards",
    title: "Drinking Games with Cards - Modern Alternatives",
    description:
      "Explore modern drinking games beyond cards. Muse Moment offers AI-powered challenges that trump traditional card games with endless variety.",
    category: "drinking-games",
    keywords: ["drinking games", "card games", "alternatives", "modern"],
    content: {
      intro:
        "Traditional card drinking games like Kings and Ring of Fire are classics, but modern alternatives like Muse Moment offer unlimited variety without needing physical cards.",
      sections: [
        {
          heading: "Beyond Traditional Cards",
          content:
            "While card games rely on fixed rules and limited combinations, AI-generated games create unique challenges every time. No more memorizing rules or running out of fresh content.",
        },
        {
          heading: "Advantages of AI-Powered Games",
          content:
            "Infinite variety, progressive difficulty, and personalized challenges based on your game mode. Plus, no lost cards or cleanup required!",
        },
        {
          heading: "When to Use Each",
          content:
            "Card games are great for low-tech situations, but AI games shine when you want fresh, customized challenges that adapt to your group and escalate in intensity.",
        },
      ],
    },
    relatedModes: ["bff"],
  },
  {
    slug: "bachelorette-party-games",
    title: "Bachelorette Party Games - Fun Ideas for the Bride",
    description:
      "Plan the perfect bachelorette party with fun games. Muse Moment's BFF mode creates hilarious dares and challenges for bride squads and bachelorette parties.",
    category: "occasions",
    keywords: [
      "bachelorette",
      "bridal shower",
      "bachelor party",
      "bride squad",
    ],
    content: {
      intro:
        "Make the bachelorette party unforgettable with games that get everyone laughing and bonding. Muse Moment scales perfectly for bride squads of any size.",
      sections: [
        {
          heading: "Bachelorette Game Ideas",
          content:
            "From embarrassing stories to daring challenges, the right game breaks the ice and creates memories. Muse Moment's AI generates age-appropriate dares that ramp up throughout the night.",
        },
        {
          heading: "Planning the Perfect Party",
          content:
            "Consider the bride's comfort level, the group size, and the venue. Start with lighter challenges and let the intensity build naturally as the night progresses.",
        },
        {
          heading: "Why Muse Moment Works",
          content:
            "Supports up to 20 players, customizable intensity, and unique challenges every time. No重复的内容, no awkward moments – just pure fun tailored to your group.",
        },
      ],
    },
    relatedModes: ["bff"],
  },
  {
    slug: "birthday-party-games",
    title: "Birthday Party Games for Adults | Muse Moment",
    description:
      "Spice up birthday celebrations with adult party games. Muse Moment offers customizable challenges for birthday parties of any size.",
    category: "occasions",
    keywords: ["birthday", "birthday party", "celebration", "adult games"],
    content: {
      intro:
        "Looking for birthday party games that adults actually want to play? Muse Moment brings the perfect mix of nostalgia and grown-up fun to any birthday celebration.",
      sections: [
        {
          heading: "Adult Birthday Party Ideas",
          content:
            "Move past pin the tail – adult birthdays deserve better games. Do or Drink challenges create hilarious moments and inside jokes that last long after the party ends.",
        },
        {
          heading: "Games for Different Birthday Styles",
          content:
            "Low-key dinner parties? Rowdy house parties? Intimate date night? Muse Moment adapts to any birthday vibe with three distinct game modes for different group dynamics.",
        },
        {
          heading: "Making Birthdays Memorable",
          content:
            "The best birthday games create stories you'll retell for years. With progressive intensity and AI-generated challenges, every game becomes unique to the birthday person and their friends.",
        },
      ],
    },
    relatedModes: ["bff", "date"],
  },
  {
    slug: "house-party-games",
    title: "House Party Games - Ultimate Guide | Muse Moment",
    description:
      "Transform your house party with the right games. Discover party games that work in any space and keep guests entertained all night.",
    category: "party-games",
    keywords: ["house party", "home party", "party entertainment", "games"],
    content: {
      intro:
        "Great house parties need great entertainment. While music and drinks set the mood, the right party game creates the memorable moments everyone talks about later.",
      sections: [
        {
          heading: "Choosing House Party Games",
          content:
            "Consider your space, guest count, and party vibe. The best games work in small apartments and large houses alike, require minimal setup, and get everyone involved.",
        },
        {
          heading: "Games That Break the Ice",
          content:
            "Nothing kills a house party faster than awkward silence. Party games that mix guests, create laughter, and build shared experiences turn strangers into friends.",
        },
        {
          heading: "Scaling for Any Party Size",
          content:
            "Muse Moment supports 2-20 players, making it versatile for intimate gatherings or blowout parties. The AI adjusts challenges based on your group size and selected intensity.",
        },
      ],
    },
    relatedModes: ["bff"],
  },
  {
    slug: "icebreaker-games-for-adults",
    title: "Icebreaker Games for Adults - Break the Ice Naturally",
    description:
      "Effective icebreaker games for adults that don't feel awkward. Muse Moment creates natural conversation and connection through shared challenges.",
    category: "party-games",
    keywords: ["icebreakers", "meeting people", "breaking the ice", "social games"],
    content: {
      intro:
        "Bad icebreakers are cringeworthy. Good ones are invisible – they get people talking and laughing without forced awkwardness. The right game breaks down barriers naturally.",
      sections: [
        {
          heading: "What Makes Icebreakers Work",
          content:
            "Effective icebreakers are voluntary, scalable, and create shared experiences. They avoid putting people on the spot and instead foster organic interaction through laughter and challenges.",
        },
        {
          heading: "Icebreakers for Different Situations",
          content:
            "Work events, parties, dates, and friend groups all need different approaches. Muse Moment offers three modes tailored to different social dynamics – from professional-ish BFF mode to intimate Couples mode.",
        },
        {
          heading: "Skipping the Awkward Phase",
          content:
            "The best icebreaker games feel like fun, not exercises. Do or Drink challenges naturally get people participating, sharing, and bonding without forced introductions or awkward questions.",
        },
      ],
    },
    relatedModes: ["bff", "date"],
  },
  {
    slug: "date-night-game-ideas",
    title: "Date Night Game Ideas - Romantic & Fun | Muse Moment",
    description:
      "Spice up date night with romantic games for couples. From playful to spicy, find the perfect game to connect with your partner.",
    category: "date-games",
    keywords: ["date night", "couple games", "romantic games", "at home dates"],
    content: {
      intro:
        "Date nights need more than dinner and a movie. Games designed for couples create connection, spark conversation, and build intimacy in ways passive entertainment can't match.",
      sections: [
        {
          heading: "Types of Date Night Games",
          content:
            "Conversation starters build emotional connection. Active challenges create shared experiences. Romantic games build intimacy. Muse Moment's Date mode combines all three with progressive intensity.",
        },
        {
          heading: "Planning the Perfect Date Night Game",
          content:
            "Choose games that match your relationship stage and comfort level. Start light, let things escalate naturally, and always prioritize mutual comfort and consent.",
        },
        {
          heading: "Why Games Work for Dates",
          content:
            "Games remove pressure, create natural conversation, and reveal personality. They're especially effective for new couples breaking barriers or established couples reconnecting through play.",
        },
      ],
    },
    relatedModes: ["date", "couples"],
  },
  {
    slug: "games-for-couples-at-home",
    title: "Games for Couples at Home - Stay In & Play",
    description:
      "Best games for couples to play at home. From romantic to spicy, discover games that make staying in the best part of date night.",
    category: "date-games",
    keywords: ["couples games", "at home", "indoor games", "relationship games"],
    content: {
      intro:
        "Who needs expensive dates when you have great games at home? Couples' games create intimacy, laughter, and connection without leaving the house.",
      sections: [
        {
          heading: "Benefits of At-Home Couple Games",
          content:
            "Privacy, comfort, and cost-effectiveness. Plus, games designed for couples deepen relationships in ways restaurants and movies can't – through active participation and shared challenges.",
        },
        {
          heading: "Choosing the Right Game",
          content:
            "Consider your relationship stage and what you want to achieve. Romantic games build connection. Spicy games build passion. Conversation games build understanding. Muse Moment offers all three in different modes.",
        },
        {
          heading: "Creating the Perfect At-Home Date",
          content:
            "Set the mood with lighting and music, remove distractions, and choose a game that matches your energy. With Muse Moment's Couples mode, challenges progress naturally from warm to spicy.",
        },
      ],
    },
    relatedModes: ["date", "couples"],
  },
  {
    slug: "truth-or-dare-alternatives",
    title: "Truth or Dare Alternatives - Modern Party Games",
    description:
      "Beyond Truth or Dare: discover modern party games with AI-powered challenges. Muse Moment offers the classic do-or-drink concept with endless variety.",
    category: "party-games",
    keywords: [
      "truth or dare",
      "alternatives",
      "party games",
      "modern games",
    ],
    content: {
      intro:
        "Truth or Dare is a classic, but it has limits – repetitive questions, awkward truths, and dares that don't match the vibe. Modern alternatives offer more variety and better experiences.",
      sections: [
        {
          heading: "Problems with Traditional Truth or Dare",
          content:
            "Limited dare options, questions that get too personal too fast, and challenges that don't scale from fun to spicy. Traditional formats also run out of fresh content quickly.",
        },
        {
          heading: "The Muse Moment Advantage",
          content:
            "AI-generated challenges mean infinite variety. Progressive intensity ensures the game matches the mood. Multiple modes adapt to friends, dates, or intimate couples. No awkward truths – just pure action.",
        },
        {
          heading: "When to Choose Which",
          content:
            "Stick with Truth or Dare for low-tech nostalgia. Choose Muse Moment when you want fresh challenges, better scaling, and experiences tailored to your specific group or relationship.",
        },
      ],
    },
    relatedModes: ["bff", "date", "couples"],
  },
  {
    slug: "new-years-eve-party-games",
    title: "New Year's Eve Party Games - Ring in the New Year",
    description:
      "Make your New Year's Eve party unforgettable with fun party games. Muse Moment creates challenges that countdown to midnight.",
    category: "occasions",
    keywords: ["new years eve", "new year", "holiday party", "celebration"],
    content: {
      intro:
        "New Year's Eve parties need great games to keep energy high until midnight. The right party game turns hours of waiting into memorable experiences.",
      sections: [
        {
          heading: "NYE Game Planning",
          content:
            "Choose games that work in countdown format, scale for fluctuating guest counts, and build energy throughout the night. Avoid games that require long explanations or complex rules.",
        },
        {
          heading: "Games That Build Anticipation",
          content:
            "Progressive intensity games work perfectly for NYE. Start light during dinner, ramp up as midnight approaches, and peak with the final challenges before the countdown.",
        },
        {
          heading: "Muse Moment for New Year's",
          content:
            "Supports late-arriving guests, scales from 2-20 players, and creates unique challenges all night. No setup required – just open the app and let the AI keep the party going.",
        },
      ],
    },
    relatedModes: ["bff"],
  },
  {
    slug: "drinking-game-rules",
    title: "Drinking Game Rules - Play Responsibly | Muse Moment",
    description:
      "Essential drinking game rules for safe fun. Learn how to play drinking games responsibly while keeping the party enjoyable.",
    category: "guides",
    keywords: ["drinking game rules", "responsible drinking", "safety", "etiquette"],
    content: {
      intro:
        "Great drinking games balance fun with responsibility. Knowing the rules ensures everyone has a good time without going too far.",
      sections: [
        {
          heading: "Golden Rules of Drinking Games",
          content:
            "Never pressure anyone to drink beyond their comfort. Know your limits and respect others'. Have non-alcoholic options available. The game is about fun, not intoxication.",
        },
        {
          heading: "Fair Play Guidelines",
          content:
            "Dares should be fun, not humiliating. Penalties should be sips, not shots. Anyone can opt out of any challenge without judgment – that's the drink alternative.",
        },
        {
          heading: "Reading the Room",
          content:
            "Good hosts know when to slow down or switch activities. Muse Moment's intensity progression lets you control the vibe – keep it light or let it escalate based on your group's comfort.",
        },
      ],
    },
    relatedModes: ["bff"],
  },
  {
    slug: "couples-relationship-games",
    title: "Relationship Games for Couples - Build Connection",
    description:
      "Strengthen your relationship with couples games. From deep conversations to spicy challenges, discover games that bring partners closer.",
    category: "date-games",
    keywords: ["relationship games", "couples", "intimacy", "connection"],
    content: {
      intro:
        "Relationship games aren't just for new couples – they're tools for ongoing connection, communication, and intimacy at any relationship stage.",
      sections: [
        {
          heading: "Types of Relationship Games",
          content:
            "Conversation games deepen understanding. Activity games build shared experiences. Intimacy games enhance physical connection. The best couples games combine multiple elements.",
        },
        {
          heading: "Games for Every Relationship Stage",
          content:
            "New couples benefit from icebreaker games. Established couples need reconnection tools. Long-term pairs often seek to reignite passion. Muse Moment's modes address all these needs.",
        },
        {
          heading: "Why Games Strengthen Relationships",
          content:
            "Games remove daily routine pressure, create novelty, and foster vulnerability. They provide structured ways to communicate, explore, and connect that don't happen in everyday life.",
        },
      ],
    },
    relatedModes: ["date", "couples"],
  },
  {
    slug: "party-games-without-props",
    title: "Party Games Without Props - No Setup Required",
    description:
      "Great party games that require zero equipment. Muse Moment is the ultimate no-props party game – just open and play with any group.",
    category: "party-games",
    keywords: ["no props", "no equipment", "minimal setup", "easy party games"],
    content: {
      intro:
        "The best party games need no setup, no cleanup, and no special equipment. Just people and a concept that gets everyone involved.",
      sections: [
        {
          heading: "Benefits of No-Props Games",
          content:
            "Spontaneous play – start anytime, anywhere. No shopping or prep required. No lost pieces or broken equipment. Perfect for impromptu gatherings and last-minute plans.",
        },
        {
          heading: "What Makes No-Props Games Work",
          content:
            "Simple rules that can be explained in seconds. Challenges that use only what people bring – themselves. Scalable formats that work for any group size.",
        },
        {
          heading: "Muse Moment: Ultimate No-Props Game",
          content:
            "All you need is a phone. No cards, dice, boards, or equipment. The AI generates infinite challenges. Works in any location with any group. Just open and start playing.",
        },
      ],
    },
    relatedModes: ["bff", "date"],
  },
  {
    slug: "fun-party-games-for-adults",
    title: "Fun Party Games for Adults - Actually Entertaining",
    description:
      "Party games adults actually enjoy. Skip the boring games – discover fun, engaging party games that keep everyone entertained.",
    category: "party-games",
    keywords: ["fun games", "entertaining", "adult party games", "good games"],
    content: {
      intro:
        "Nothing kills a party faster than a boring game. The best adult party games balance simplicity, engagement, and just the right amount of edge.",
      sections: [
        {
          heading: "What Makes Party Games Fun",
          content:
            "Clear rules that don't require reading manuals. Challenges that get everyone participating, not just one person. Progressive intensity that builds energy. Flexibility to adapt to the vibe.",
        },
        {
          heading: "Avoiding Game Killers",
          content:
            "Over-complicated rules, long wait times between turns, and challenges that isolate players are the fastest ways to clear a room. Good games keep everyone involved.",
        },
        {
          heading: "Why Muse Moment Works",
          content:
            "AI-generated challenges keep things fresh. Turn-based play keeps everyone engaged. Multiple intensity modes match any party vibe. Zero setup means instant fun.",
        },
      ],
    },
    relatedModes: ["bff"],
  },
  {
    slug: "halloween-party-games",
    title: "Halloween Party Games - Spooky Fun | Muse Moment",
    description:
      "Spooky party games for Halloween gatherings. From haunted house parties to costume contests, find the perfect games for your Halloween celebration.",
    category: "occasions",
    keywords: ["halloween", "costume party", "spooky games", "october"],
    content: {
      intro:
        "Halloween parties need games that match the spooky atmosphere. Whether you're hosting a costume party or a haunted house gathering, the right game keeps the scares fun and the drinks flowing.",
      sections: [
        {
          heading: "Halloween Game Ideas",
          content:
            "Spooky dares, costume-based challenges, and themed drinking games. Muse Moment's AI can generate Halloween-appropriate challenges that fit any party vibe.",
        },
        {
          heading: "Adult Halloween Parties",
          content:
            "Move beyond pumpkin carving and bobbing for apples. Adult Halloween parties deserve games that match the costumes and cocktails. Progressive intensity keeps energy high all night.",
        },
        {
          heading: "Tips for Halloween Games",
          content:
            "Keep challenges themed but safe. Incorporate costumes into dares. Match the intensity to your crowd – from family-friendly to after-dark scary.",
        },
      ],
    },
    relatedModes: ["bff"],
  },
  {
    slug: "christmas-party-games",
    title: "Christmas Party Games - Holiday Fun | Muse Moment",
    description:
      "Festive party games for Christmas celebrations. From office holiday parties to family gatherings, find games that spread holiday cheer.",
    category: "occasions",
    keywords: ["christmas", "holiday party", "xmas games", "festive"],
    content: {
      intro:
        "Christmas parties deserve games as festive as the season. Whether it's an office holiday party or a family gathering, the right games create memorable holiday moments.",
      sections: [
        {
          heading: "Christmas Party Game Ideas",
          content:
            "Secret Santa exchanges, holiday-themed dares, and festive challenges. Games that work with mulled wine and Christmas cookies alike.",
        },
        {
          heading: "Office Holiday Parties",
          content:
            "Professional but fun – the balance every office party needs. Games that break down workplace barriers without crossing HR lines. Muse Moment's BFF mode scales for any office size.",
        },
        {
          heading: "Family-Friendly Options",
          content:
            "Holiday gatherings with family need inclusive games. Challenges that work across generations and comfort levels. Keep it festive and fun for everyone.",
        },
      ],
    },
    relatedModes: ["bff"],
  },
  {
    slug: "valentines-day-games",
    title: "Valentine's Day Games for Couples - Romantic Fun",
    description:
      "Romantic games for Valentine's Day. Spice up your February 14th with couples games that create connection and intimacy.",
    category: "occasions",
    keywords: ["valentines day", "valentine's", "romantic games", "february 14"],
    content: {
      intro:
        "Valentine's Day is about connection, and games are the perfect way to deepen your bond. Whether you're in a new relationship or celebrating years together, the right game makes February 14th unforgettable.",
      sections: [
        {
          heading: "Romantic Valentine's Games",
          content:
            "Conversation starters that reveal feelings. Romantic challenges that build intimacy. Spicy dares that heat up the night. Muse Moment's Date and Couples modes cover every relationship stage.",
        },
        {
          heading: "At-Home Valentine's Dates",
          content:
            "Skip the crowded restaurants. An intimate game night at home creates deeper connection than an overpriced prix fixe menu. Add wine, dim lighting, and let the games begin.",
        },
        {
          heading: "New vs. Established Relationships",
          content:
            "New couples benefit from icebreaker games that reveal compatibility. Long-term partners need games that reignite spark. Choose the mode that matches your relationship stage.",
        },
      ],
    },
    relatedModes: ["date", "couples"],
  },
  {
    slug: "girls-night-games",
    title: "Girls Night Games - Fun for Besties | Muse Moment",
    description:
      "The best games for girls night in. From wine nights to bridal showers, find games that create unforgettable moments with your best friends.",
    category: "occasions",
    keywords: ["girls night", "ladies night", "best friends", "wine night"],
    content: {
      intro:
        "Girls night deserves better than scrolling through phones together. The right game transforms wine nights, sleepovers, and bestie gatherings into legendary events.",
      sections: [
        {
          heading: "Girls Night Game Ideas",
          content:
            "Hilarious dares, embarrassing truth questions, and challenges that test your friendship. The best girls nights end with inside jokes that last years.",
        },
        {
          heading: "Wine Night Games",
          content:
            "Wine + games = magic. Challenges that pair perfectly with your favorite bottles. Progressive intensity that matches the wine flow throughout the night.",
        },
        {
          heading: "From Small Groups to Bride Squads",
          content:
            "Intimate wine nights or massive bachelorette parties – Muse Moment scales from 2 to 20 players. AI-generated challenges keep things fresh no matter your group size.",
        },
      ],
    },
    relatedModes: ["bff"],
  },
  {
    slug: "guys-night-games",
    title: "Guys Night Games - Bromingo Activities",
    description:
      "Party games for guys night. From poker nights to bachelor parties, find games that keep the bromance strong and the competition flowing.",
    category: "occasions",
    keywords: ["guys night", "bachelor party", "groomsmen", "bros"],
    content: {
      intro:
        "Guys night needs games that balance competition with camaraderie. Whether it's a low-key poker night or an all-out bachelor party, the right game keeps the energy high.",
      sections: [
        {
          heading: "Guys Night Game Ideas",
          content:
          "Competitive dares, skill challenges, and games that bring out everyone's competitive side. The best guys nights combine friendly competition with unforgettable moments.",
        },
        {
          heading: "Bachelor Party Games",
          content:
            "Send the groom off properly. Games that create memories (and mild embarrassment) without crossing lines. Muse Moment scales for any groom squad size.",
        },
        {
          heading: "Low-Key vs. Wild Nights",
          content:
            "Poker nights need chill games. House parties need energy boosters. Match the game intensity to your night plans. Muse Moment's progressive intensity adapts to any vibe.",
        },
      ],
    },
    relatedModes: ["bff"],
  },
  {
    slug: "adult-birthday-games",
    title: "Adult Birthday Party Games - Fun Ideas",
    description:
      "Adult birthday party games that actually entertain. Skip the cheesy games – discover party games perfect for adult birthday celebrations.",
    category: "occasions",
    keywords: ["adult birthday", "birthday party", "adult games", "celebration"],
    content: {
      intro:
        "Adult birthdays deserve better than pin the tail on the donkey. The right party games turn birthday celebrations into events everyone actually wants to attend.",
      sections: [
        {
          heading: "Adult Birthday Game Ideas",
          content:
            "Drinking games with dignity, dares that match the birthday person's humor, and challenges that create viral moments. Games that work whether you're turning 21 or 50.",
        },
        {
          heading: "Milestone Birthdays",
          content:
            "21st, 30th, 40th, 50th – milestone birthdays need milestone games. Challenges that celebrate (or gently roast) the birthday person. Create memories they'll laugh about for decades.",
        },
        {
          heading: "Birthday Party Planning",
          content:
            "Match the game to the guest list. Office friends need different energy than college buddies. Muse Moment's modes let you customize the intensity for any birthday crowd.",
        },
      ],
    },
    relatedModes: ["bff"],
  },
  {
    slug: "cheap-party-games",
    title: "Cheap Party Games - Budget-Friendly Fun",
    description:
      "Party games that don't break the bank. Discover budget-friendly party games that provide maximum fun without expensive equipment or materials.",
    category: "party-games",
    keywords: ["cheap", "budget", "free games", "low cost"],
    content: {
      intro:
        "Great parties don't require expensive equipment. The best party games need nothing more than people and a concept – no pricey gear, no complicated setups, no stress on your wallet.",
      sections: [
        {
          heading: "Free Party Game Options",
          content:
            "Games that use only what you have: your guests and their phones. No purchases required. Muse Moment is free to play and works on any device – zero cost, maximum fun.",
        },
        {
          heading: "Budget Party Planning",
          content:
            "Spend on drinks and food, not games. Digital games like Muse Moment provide hours of entertainment for free. Save your budget for what actually matters – the beverages and snacks.",
        },
        {
          heading: "Last-Minute Party Solutions",
          content:
            "Forgot to plan games? No problem. Open Muse Moment and start playing instantly. No shopping, no setup, no stress. Perfect for spontaneous gatherings.",
        },
      ],
    },
    relatedModes: ["bff", "date"],
  },
  {
    slug: "outdoor-party-games",
    title: "Outdoor Party Games - Backyard Fun",
    description:
      "Party games perfect for outdoor gatherings and backyard parties. From summer BBQs to camping trips, find games that work in the great outdoors.",
    category: "party-games",
    keywords: ["outdoor", "backyard", "summer games", "outside"],
    content: {
      intro:
        "Outdoor parties need games that work in open spaces, handle variable group sizes, and keep the energy flowing from sunset to bonfire time.",
      sections: [
        {
          heading: "Outdoor Game Considerations",
          content:
            "Games that don't require tables. Challenges that work with ambient noise. Activities that accommodate people wandering in and out. Digital games like Muse Moment are perfect for outdoor parties.",
        },
        {
          heading: "Summer BBQ Games",
          content:
            "Backyard gatherings need casual games that don't interrupt the flow. Games that work between burgers and beers. Something people can pick up and put down as they mingle.",
        },
        {
          heading: "Camping and Beach Games",
          content:
            "Minimal packing, maximum fun. Games that work on phones without needing WiFi. Muse Moment generates challenges anywhere – perfect for remote adventures.",
        },
      ],
    },
    relatedModes: ["bff"],
  },
  {
    slug: "small-group-games",
    title: "Games for Small Groups - Intimate Fun",
    description:
      "The best games for small groups and intimate gatherings. Discover party games that work perfectly with 2-6 people.",
    category: "party-games",
    keywords: ["small groups", "intimate", "few people", "close friends"],
    content: {
      intro:
        "Small group dynamics are different from large parties. The best games for 2-6 people create deeper connections and more memorable moments without needing a crowd.",
      sections: [
        {
          heading: "Small Group Advantages",
          content:
            "More personal challenges. Better conversation flow. Everyone participates instead of getting lost in the crowd. Small group games create stronger bonds and funnier memories.",
        },
        {
          heading: "Dinner Party Games",
          content:
            "Games that work between courses. Challenges that don't disrupt the table. Activities that enhance the conversation without dominating the evening. Perfect for intimate dinner parties.",
        },
        {
          heading: "Two-Person Games",
          content:
            "Date nights, couples, and best friends need games that work with just two people. Muse Moment's Date and Couples modes are designed specifically for two-player intimacy.",
        },
      ],
    },
    relatedModes: ["bff", "date", "couples"],
  },
  {
    slug: "virtual-party-games",
    title: "Virtual Party Games - Online Fun | Muse Moment",
    description:
      "Party games for virtual gatherings and online parties. Keep remote friends connected with games that work over video calls and screens.",
    category: "party-games",
    keywords: ["virtual", "online", "zoom games", "remote"],
    content: {
      intro:
        "Distance doesn't mean you can't party together. Virtual party games keep far-flung friends connected, create shared experiences, and make online gatherings actually fun.",
      sections: [
        {
          heading: "Making Virtual Parties Work",
          content:
            "Screen-share challenges that everyone can see. Turn-based games that handle connection delays. Activities that don't require everyone to download something new.",
        },
        {
          heading: "Remote Friend Groups",
          content:
            "College friends scattered across the country. Family members in different time zones. Muse Moment works via screen-share, letting distant groups play together like they're in the same room.",
        },
        {
          heading: "Tips for Virtual Gaming",
          content:
            "Use a good microphone. Share the right screen. Allow for connection delays. Choose games that don't require physical props or simultaneous action.",
        },
      ],
    },
    relatedModes: ["bff", "date"],
  },
  {
    slug: "pregame-games",
    title: "Pregame Games - Start the Night Right",
    description:
      "The best pregame games to get the party started. Fun drinking games and challenges perfect for pre-gaming before a night out.",
    category: "drinking-games",
    keywords: ["pregame", "pre-gaming", "pre-party", "night out"],
    content: {
      intro:
        "A great night out starts with a great pregame. The right games build energy, break the ice, and get everyone in the party mood before you head out.",
      sections: [
        {
          heading: "Pregame vs. House Party",
          content:
            "Pregames need quick, energetic games that build momentum. House parties need sustained entertainment. Muse Moment's progressive intensity works for both – start chill, ramp up as the night progresses.",
        },
        {
          heading: "Quick Pregame Games",
          content:
            "Games that work in 30-45 minutes. Challenges that get people laughing and loosened up without needing hours of commitment. Perfect for the pre-dinner drink session.",
        },
        {
          heading: "Group Size Flexibility",
          content:
            "Pregames range from 3 people to full squad sizes. Muse Moment scales from intimate pre-dinner drinks to full-blown pregame ragers. AI generates challenges for any group size.",
        },
      ],
    },
    relatedModes: ["bff"],
  },
  {
    slug: "two-player-games",
    title: "Two Player Games - For Couples & Besties",
    description:
      "The best two-player games for couples and close friends. Discover games designed specifically for one-on-one fun and connection.",
    category: "party-games",
    keywords: ["two player", "2 player", "one-on-one", "solo games"],
    content: {
      intro:
        "Two-player games create deeper connections than group activities. Whether it's date night or bestie bonding, the right one-on-one game builds memorable moments.",
      sections: [
        {
          heading: "Couples Games",
          content:
            "Intimate challenges that build connection. Romantic dares that spark conversation. Spicy games that heat things up. Muse Moment's Date and Couples modes are designed specifically for two players.",
        },
        {
          heading: "Best Friend Games",
          content:
            "Games that test friendship in the best way. Hilarious challenges that create inside jokes. Competitive dares that reveal how well you really know each other.",
        },
        {
          heading: "Advantages of Two-Player Games",
          content:
            "More personal than group games. No waiting for turns. Deeper conversations. Intensity that matches your relationship. Perfect for quiet nights in.",
        },
      ],
    },
    relatedModes: ["date", "couples"],
  },
  {
    slug: "drinking-games-for-couples",
    title: "Drinking Games for Couples - Date Night Fun",
    description:
      "Romantic drinking games for couples. Spice up date night with two-player drinking games designed for partners.",
    category: "drinking-games",
    keywords: ["couples drinking games", "date night drinks", "romantic drinking", "two player"],
    content: {
      intro:
        "Drinking games aren't just for parties – couples can use them to spice up date nights, deepen connection, and add playful competition to relationships.",
      sections: [
        {
          heading: "Romantic Drinking Games",
          content:
            "Challenges that reveal things about each other. Dares that build intimacy. Games that turn wine nights into adventures. Muse Moment's Date mode creates romantic, progressively intense challenges.",
        },
        {
          heading: "At-Home Date Nights",
          content:
            "Skip the bar. Create your own couples' drinking experience at home. More intimate, more affordable, and more memorable than a night out.",
        },
        {
          heading: "Safe Fun for Couples",
          content:
            "Know your limits together. Games should enhance connection, not lead to intoxication. The best couples' games balance fun with moderation.",
        },
      ],
    },
    relatedModes: ["date", "couples"],
  },
  {
    slug: "anniversary-games",
    title: "Anniversary Games for Couples - Celebrate Love",
    description:
      "Romantic games for anniversary celebrations. Make your anniversary special with couples games that create memorable moments.",
    category: "occasions",
    keywords: ["anniversary", "celebration", "romantic games", "couple milestones"],
    content: {
      intro:
        "Anniversaries deserve more than just dinner. Games designed for couples create shared experiences, deepen connections, and make milestone celebrations unforgettable.",
      sections: [
        {
          heading: "Anniversary Game Ideas",
          content:
            "Challenges that celebrate your relationship. Games that remind you why you fell in love. Romantic dares that reignite the spark. Muse Moment's Couples mode creates perfect anniversary experiences.",
        },
        {
          heading: "Milestone Anniversaries",
          content:
            "1st, 5th, 10th, 25th – milestone anniversaries need special celebrations. Games that reflect on your journey together and look forward to the future.",
        },
        {
          heading: "At-Home Anniversary Dates",
          content:
            "Avoid the crowded restaurants. An intimate game night at home creates deeper connection than any prix fixe menu. Add your favorite wine and let the games begin.",
        },
      ],
    },
    relatedModes: ["date", "couples"],
  },
  {
    slug: "long-distance-relationship-games",
    title: "Long Distance Relationship Games - Stay Connected",
    description:
      "Games for long distance relationships. Stay connected with your partner through virtual games designed for remote couples.",
    category: "date-games",
    keywords: ["long distance", "LDR", "remote couples", "virtual dating"],
    content: {
      intro:
        "Long distance relationships need creative ways to maintain connection. Games designed for remote play help couples stay bonded across miles and time zones.",
      sections: [
        {
          heading: "Virtual Couple Games",
          content:
            "Screen-share challenges that work over video calls. Turn-based activities that handle connection delays. Games that create shared experiences despite the distance.",
        },
        {
          heading: "Scheduled Date Nights",
          content:
            "Make virtual dates feel special. Games that give structure to video calls. Activities that go beyond 'how was your day' and create real connection.",
        },
        {
          heading: "Keeping the Spark Alive",
          content:
            "Distance challenges relationships, but games help maintain intimacy. Romantic challenges, spicy dares, and conversation starters keep long-distance love exciting.",
        },
      ],
    },
    relatedModes: ["date", "couples"],
  },
  {
    slug: "relationship-icebreakers",
    title: "Relationship Icebreakers - Deepen Your Bond",
    description:
      "Icebreaker games for couples to deepen their connection. Discover conversation starters and activities that bring partners closer.",
    category: "date-games",
    keywords: ["relationship icebreakers", "couple conversations", "deep questions", "connection"],
    content: {
      intro:
        "Even long-term couples can discover new things about each other. Relationship icebreakers create conversations that deepen bonds and reveal new facets of your partner.",
      sections: [
        {
          heading: "Couple Conversation Starters",
          content:
            "Questions that go beyond daily logistics. Challenges that reveal dreams and fears. Games that create the kinds of conversations that happened when you first met.",
        },
        {
          heading: "Breaking Routine",
          content:
            "Relationships fall into ruts. Games break patterns and create new shared experiences. Even 10 minutes of play can refresh a stale routine.",
        },
        {
          heading: "New vs. Established Couples",
          content:
            "New couples need icebreakers to learn about each other. Established couples need games that reignite curiosity. Muse Moment's modes work for every relationship stage.",
        },
      ],
    },
    relatedModes: ["date", "couples"],
  },
  {
    slug: "bridal-shower-games",
    title: "Bridal Shower Games - Fun for Brides | Muse Moment",
    description:
      "Classy and fun bridal shower games. From traditional to modern, find the perfect games to celebrate the bride-to-be.",
    category: "occasions",
    keywords: ["bridal shower", "bride to be", "wedding shower", "bridal"],
    content: {
      intro:
        "Bridal showers need games that balance fun with appropriateness. The right activities honor the bride, entertain guests, and create memorable pre-wedding moments.",
      sections: [
        {
          heading: "Bridal Shower Game Ideas",
          content:
            "Games about the couple. Challenges that predict wedding success. Activities that involve all guests. Muse Moment can generate family-friendly challenges perfect for mixed-age groups.",
        },
        {
          heading: "Classy & Fun",
          content:
            "Modern bridal showers skip the embarrassing stuff. Games that are fun without being cringeworthy. Challenges that work for grandma and the bride squad alike.",
        },
        {
          heading: "Group Size Flexibility",
          content:
            "Small intimate showers or large guest lists – Muse Moment scales to fit. AI generates fresh challenges so every bridal shower feels unique.",
        },
      ],
    },
    relatedModes: ["bff"],
  },
  {
    slug: "graduation-party-games",
    title: "Graduation Party Games - Celebrate Achievement",
    description:
      "Party games for graduation celebrations. From high school to college graduation, find games that celebrate the graduate's achievement.",
    category: "occasions",
    keywords: ["graduation", "grad party", "graduate", "achievement"],
    content: {
      intro:
        "Graduation parties celebrate achievement and mark transitions. The right games honor the graduate, entertain mixed-age guests, and create lasting memories of the milestone.",
      sections: [
        {
          heading: "Graduation Party Ideas",
          content:
            "Games about the graduate's journey. Challenges that celebrate their future. Activities that work for classmates and family members alike.",
        },
        {
          heading: "Age-Appropriate Fun",
          content:
            "High school graduations have different vibes than college celebrations. Match the game intensity to the graduate and guest list. Keep it fun for family but entertaining for friends.",
        },
        {
          heading: "Flexible for Any Crowd",
          content:
            "Family dinners or all-night ragers – Muse Moment scales to fit any graduation celebration. Progressive intensity lets you control the party energy.",
        },
      ],
    },
    relatedModes: ["bff"],
  },
  {
    slug: "memorial-day-games",
    title: "Memorial Day Party Games - Weekend Fun",
    description:
      "Party games for Memorial Day weekend. From backyard BBQs to lake house gatherings, find games that kick off summer right.",
    category: "occasions",
    keywords: ["memorial day", "holiday weekend", "summer kickoff", "may"],
    content: {
      intro:
        "Memorial Day weekend kicks off summer party season. The right games enhance outdoor gatherings, BBQs, and weekend getaways with friends and family.",
      sections: [
        {
          heading: "Memorial Day Party Ideas",
          content:
            "Backyard games that work between burgers. Lake house activities for the whole group. Flexible games that accommodate fluctuating holiday weekend crowds.",
        },
        {
          heading: "Outdoor Friendly",
          content:
            "Memorial Day = outdoors. Games that don't require tables. Challenges that work with ambient noise. Digital games like Muse Moment are perfect for outdoor celebrations.",
        },
        {
          heading: "Multi-Generational Fun",
          content:
            "Memorial Day gatherings often mix generations. Games that work for college friends and extended family. Adjust intensity based on your guest mix.",
        },
      ],
    },
    relatedModes: ["bff"],
  },
  {
    slug: "labor-day-games",
    title: "Labor Day Party Games - End of Summer Fun",
    description:
      "Party games for Labor Day weekend. Close out summer with games perfect for BBQs, pool parties, and final summer flings.",
    category: "occasions",
    keywords: ["labor day", "end of summer", "september", "holiday weekend"],
    content: {
      intro:
        "Labor Day weekend is summer's last hurrah. The right games send off the season with memorable parties, BBQs, and celebrations with friends.",
      sections: [
        {
          heading: "Labor Day Party Ideas",
          content:
            "Pool party games that work in swimwear. BBQ challenges that don't interrupt the grilling. Flexible activities for weekend-long house parties.",
        },
        {
          heading: "Summer Finale Energy",
          content:
            "Labor Day parties have that 'last chance of summer' energy. Games that match the festive, slightly melancholy vibe of summer's end. Make the final weekend count.",
        },
        {
          heading: "Any Setting, Any Crowd",
          content:
            "Beach houses, backyards, or city rooftops – Muse Moment works anywhere. Accommodates guests arriving and leaving throughout the long weekend.",
        },
      ],
    },
    relatedModes: ["bff"],
  },
  {
    slug: "fourth-of-july-games",
    title: "4th of July Party Games - Independence Day Fun",
    description:
      "Patriotic party games for July 4th celebrations. From backyard BBQs to fireworks parties, find games perfect for Independence Day.",
    category: "occasions",
    keywords: ["4th of july", "july 4th", "independence day", "patriotic"],
    content: {
      intro:
        "Fourth of July parties need games that can compete with fireworks. The right activities keep the energy high all day until the sky lights up at night.",
      sections: [
        {
          heading: "July 4th Party Ideas",
          content:
            "All-day games for marathon parties. Challenges that work between BBQ and fireworks. Activities that build energy toward the evening grand finale.",
        },
        {
          heading: "Outdoor BBQ Games",
          content:
            "Most 4th of July parties are outdoors. Games that don't need tables. Challenges that work with sun, noise, and fluctuating group sizes as people come and go.",
        },
        {
          heading: "Family-Friendly Options",
          content:
            "July 4th often means mixed-age crowds. Games that work for kids during the day and adults after bedtime. Adjust based on your guest list timing.",
        },
      ],
    },
    relatedModes: ["bff"],
  },
  {
    slug: "super-bowl-party-games",
    title: "Super Bowl Party Games - Football Fun",
    description:
      "Party games for Super Bowl Sunday. From pre-game to post-game, find activities that keep your Super Bowl party entertaining.",
    category: "occasions",
    keywords: ["super bowl", "football", "super bowl sunday", "sports party"],
    content: {
      intro:
        "Super Bowl parties are marathons, not sprints. The right games keep guests entertained during pre-game, lulls in the action, and post-game celebrations.",
      sections: [
        {
          heading: "Super Bowl Party Timing",
          content:
            "Pre-game energy needs different activities than halftime entertainment. Games that can pause for commercials and big plays. Flexible timing is key.",
        },
        {
          heading: "Football Fans & Casual Viewers",
          content:
            "Some guests are there for every snap. Others are just for the commercials and snacks. Games that engage both levels of investment without disrupting the serious fans.",
        },
        {
          heading: "Halftime Entertainment",
          content:
            "Halftime is perfect for quick games. Challenges that complete in 15-20 minutes before the second half kicks off. Keep energy high during the show.",
        },
      ],
    },
    relatedModes: ["bff"],
  },
  {
    slug: "march-madness-games",
    title: "March Madness Party Games - Basketball Fun",
    description:
      "Party games for March Madness tournaments. From bracket watching to final four, find games perfect for basketball watch parties.",
    category: "occasions",
    keywords: ["march madness", "basketball", "tournament", "bracket"],
    content: {
      intro:
        "March Madness watch parties span weeks. The right games keep things fresh during endless games, commercial breaks, and bracket-busting upsets.",
      sections: [
        {
          heading: "Tournament Party Ideas",
          content:
            "Games that work during blowouts. Challenges for between games. Activities that keep energy high throughout the marathon tournament.",
        },
        {
          heading: "Bracket Watching Fun",
          content:
            "Not everyone cares about every game. Games that engage both hardcore fans and casual watchers just there for the party vibe.",
        },
        {
          heading: "Weekend-Long Entertainment",
          content:
            "March Madness is a multi-week event. Games that stay fresh across multiple viewing parties. Muse Moment's AI generates unique challenges every time.",
        },
      ],
    },
    relatedModes: ["bff"],
  },
  {
    slug: "engagement-party-games",
    title: "Engagement Party Games - Celebrate the Couple",
    description:
      "Fun and classy games for engagement parties. Celebrate the newly engaged couple with games that honor their relationship.",
    category: "occasions",
    keywords: ["engagement party", "newly engaged", "couple games", "celebration"],
    content: {
      intro:
        "Engagement parties celebrate the beginning of a couple's wedding journey. The right games honor the relationship, entertain guests, and create memorable moments.",
      sections: [
        {
          heading: "Engagement Party Ideas",
          content:
            "Games about the couple's story. Challenges that test how well guests know the relationship. Activities that involve friends and family in celebrating the engagement.",
        },
        {
          heading: "Classy & Fun Balance",
          content:
            "Engagement parties celebrate love, not embarrassment. Games that are heartwarming and fun without crossing lines. Keep it appropriate for all guests.",
        },
        {
          heading: "Flexible Guest Lists",
          content:
            "Engagement parties range from intimate dinners to full receptions. Muse Moment scales to fit any size celebration with appropriate challenges.",
        },
      ],
    },
    relatedModes: ["bff", "date"],
  },
  {
    slug: "cocktail-party-games",
    title: "Cocktail Party Games - Sophisticated Fun",
    description:
      "Elegant games for cocktail parties. From dinner parties to mixers, find games that add sophistication to your cocktail hour.",
    category: "party-games",
    keywords: ["cocktail party", "dinner party", "sophisticated", "elegant"],
    content: {
      intro:
        "Cocktail parties need games that match the atmosphere – sophisticated, engaging, but not disruptive. The right activities enhance conversation without dominating the event.",
      sections: [
        {
          heading: "Cocktail Party Atmosphere",
          content:
            "Games that work with drinks in hand. Challenges that don't require putting down cocktails. Activities that enhance mingling rather than replacing it.",
        },
        {
          heading: "Conversation Starters",
          content:
            "Cocktail parties are about conversation. Games that break the ice, reveal interesting facts, and give people reasons to talk beyond small talk.",
        },
        {
          heading: "Elegant Entertainment",
          content:
            "Cocktail parties aren't raucous affairs. Choose games that match the sophisticated vibe. Muse Moment's progressive intensity lets you control the energy level.",
        },
      ],
    },
    relatedModes: ["bff", "date"],
  },
  {
    slug: "picnic-games",
    title: "Picnic Games - Outdoor Fun for All",
    description:
      "Games perfect for picnics and outdoor dining. From park dates to family picnics, find activities that enhance your outdoor meal.",
    category: "party-games",
    keywords: ["picnic", "outdoor dining", "park games", "outside"],
    content: {
      intro:
        "Picnics combine food, sunshine, and relaxation. The right games add entertainment without requiring equipment or interrupting the leisurely outdoor vibe.",
      sections: [
        {
          heading: "Picnic-Friendly Games",
          content:
            "Nothing to carry but your phone. Games that work on blankets or grass. Challenges that don't require tables or flat surfaces. Perfect for park dates and family outings.",
        },
        {
          heading: "Group Size Flexibility",
          content:
            "Romantic picnics for two or family gatherings for twelve – the right games scale to any size. Muse Moment works for intimate dates and larger groups alike.",
        },
        {
          heading: "Easy Setup, Easy Cleanup",
          content:
            "Picnics should be simple. Games that start instantly and pack away in seconds. No equipment, no mess, just fun in the sun.",
        },
      ],
    },
    relatedModes: ["bff", "date"],
  },
  {
    slug: "game-night-ideas",
    title: "Game Night Ideas - Host the Perfect Night",
    description:
      "Game night ideas for hosts. From themed nights to regular gatherings, discover how to host the ultimate game night.",
    category: "guides",
    keywords: ["game night", "hosting", "game night ideas", "party hosting"],
    content: {
      intro:
        "Great game nights don't happen by accident. The right combination of games, snacks, and atmosphere transforms a regular evening into an event people look forward to attending.",
      sections: [
        {
          heading: "Planning Game Night",
          content:
            "Choose games that fit your group size and vibe. Have backup options ready. Create a comfortable setup with good lighting and seating. Plan snacks that don't interrupt gameplay.",
        },
        {
          heading: "Game Night Themes",
          content:
            "Themed nights add excitement. Poker nights, trivia nights, or progressive intensity nights with Muse Moment. Themes give regular gatherings a sense of occasion.",
        },
        {
          heading: "Frequency and Consistency",
          content:
            "Monthly game nights build traditions. The same group + evolving games = deepening friendships. Muse Moment's variety keeps recurring nights fresh forever.",
        },
      ],
    },
    relatedModes: ["bff", "date"],
  },
  {
    slug: "housewarming-party-games",
    title: "Housewarming Party Games - New Home Fun",
    description:
      "Party games for housewarming celebrations. Help break in the new home with games perfect for housewarming parties.",
    category: "occasions",
    keywords: ["housewarming", "new home", "moving", "house party"],
    content: {
      intro:
        "Housewarming parties celebrate new spaces and new beginnings. The right games help guests feel comfortable, create memories in the new home, and break the space in properly.",
      sections: [
        {
          heading: "Housewarming Party Ideas",
          content:
            "Games that incorporate the new space. Challenges that help guests explore the house. Activities that create first memories in your new home.",
        },
        {
          heading: "Breaking in Rooms",
          content:
            "Different games work in different spaces. Kitchen challenges, living room activities, backyard games. Use the whole house and create memories in every room.",
        },
        {
          heading: "Mixed Guest Lists",
          content:
            "Housewarmings combine friend groups. Games that help people from different parts of your life mingle and connect. Icebreakers that unite neighbors, coworkers, and childhood friends.",
        },
      ],
    },
    relatedModes: ["bff"],
  },
];

export const categoryPages = [
  {
    slug: "party-games",
    title: "Party Games - Ultimate Collection | Muse Moment",
    description:
      "Discover the best party games for every occasion. From icebreakers to drinking games, find the perfect game for your next gathering.",
    intro: "The right party game transforms gatherings from awkward to unforgettable. Whether you're hosting five friends or twenty, the perfect game breaks the ice, creates laughter, and builds memories that last long after the party ends.",
    relatedTopics: [
      "party-games-for-groups",
      "house-party-games",
      "icebreaker-games-for-adults",
      "party-games-without-props",
      "fun-party-games-for-adults",
    ],
  },
  {
    slug: "drinking-games",
    title: "Drinking Games - Safe & Fun | Muse Moment",
    description:
      "Explore drinking games that prioritize fun over excess. Modern alternatives to traditional drinking games with AI-powered challenges.",
    intro: "Drinking games should be about laughter and connection, not intoxication. The best drinking games balance fun challenges with responsible play, creating memorable experiences without going too far.",
    relatedTopics: [
      "drinking-games-with-cards",
      "drinking-game-rules",
      "truth-or-dare-alternatives",
      "party-games-for-groups",
    ],
  },
  {
    slug: "date-night-games",
    title: "Date Night Games - Romantic & Exciting | Muse Moment",
    description:
      "Spice up your date nights with romantic games for couples. From conversation starters to spicy challenges, find the perfect game.",
    intro: "Great date nights need great entertainment. Games designed for couples create connection, spark intimacy, and transform routine nights into memorable experiences – all from the comfort of home.",
    relatedTopics: [
      "date-night-game-ideas",
      "games-for-couples-at-home",
      "couples-relationship-games",
      "party-games-without-props",
    ],
  },
  {
    slug: "games-for-couples",
    title: "Games for Couples - Deepen Your Connection",
    description:
      "Relationship-strengthening games for couples. Discover games that build intimacy, communication, and passion between partners.",
    intro: "Couples who play together, stay together. Games designed specifically for partners create shared experiences, deepen emotional bonds, and keep relationships fresh and exciting.",
    relatedTopics: [
      "games-for-couples-at-home",
      "couples-relationship-games",
      "date-night-game-ideas",
      "truth-or-dare-alternatives",
    ],
  },
  {
    slug: "games-for-friends",
    title: "Games for Friends - Group Fun | Muse Moment",
    description:
      "The best games to play with friends. Party games that work for any friend group and create hilarious shared experiences.",
    intro: "Friends who laugh together, stay together. The right game transforms any friend hangout into an event to remember, creating inside jokes and shared stories that strengthen your bond.",
    relatedTopics: [
      "party-games-for-groups",
      "icebreaker-games-for-adults",
      "house-party-games",
      "fun-party-games-for-adults",
    ],
  },
  {
    slug: "drinking-games-for-two",
    title: "Drinking Games for Two - Couples Fun",
    description:
      "The best drinking games for two people. Perfect for date nights and intimate couples activities at home.",
    intro: "Drinking games aren't just for large parties. Couples can use two-player drinking games to spice up date nights, create intimate moments, and add playful fun to relationships.",
    relatedTopics: [
      "drinking-games-for-couples",
      "date-night-game-ideas",
      "games-for-couples-at-home",
      "two-player-games",
    ],
  },
  {
    slug: "party-game-ideas",
    title: "Party Game Ideas - Ultimate Collection",
    description:
      "Comprehensive collection of party game ideas for every occasion. Find the perfect game for your next party or gathering.",
    intro: "Great parties need great games. This collection of party game ideas covers every occasion, group size, and vibe – from intimate dinners to blowout ragers.",
    relatedTopics: [
      "party-games-for-groups",
      "house-party-games",
      "outdoor-party-games",
      "small-group-games",
      "game-night-ideas",
    ],
  },
  {
    slug: "couple-activities",
    title: "Couple Activities - Fun Things to Do",
    description:
      "Fun activities for couples to do together. From date night ideas to spontaneous fun, discover activities that strengthen relationships.",
    intro: "Relationships need shared activities to stay fresh and connected. The right couple activities create memories, deepen bonds, and keep relationships exciting long-term.",
    relatedTopics: [
      "date-night-game-ideas",
      "games-for-couples-at-home",
      "anniversary-games",
      "relationship-icebreakers",
    ],
  },
  {
    slug: "online-party-games",
    title: "Online Party Games - Virtual Entertainment",
    description:
      "Best party games for online play and virtual gatherings. Keep remote groups connected with games that work over the internet.",
    intro: "Distance doesn't mean you can't party together. Online party games keep far-flung friends and family connected, creating shared experiences across screens and time zones.",
    relatedTopics: [
      "virtual-party-games",
      "long-distance-relationship-games",
      "party-games-without-props",
      "small-group-games",
    ],
  },
];

// Helper function to get page by slug
export const getPageBySlug = (slug) => {
  return [...topicPages, ...categoryPages].find((page) => page.slug === slug);
};

// Helper function to get pages by category
export const getPagesByCategory = (category) => {
  return topicPages.filter((page) => page.category === category);
};

// Helper function to get related pages
export const getRelatedPages = (currentSlug, limit = 4) => {
  const currentPage = getPageBySlug(currentSlug);
  if (!currentPage) return [];

  let related = [];

  // If it has explicitly defined related topics, use those
  if (currentPage.relatedTopics) {
    related = currentPage.relatedTopics
      .map((slug) => getPageBySlug(slug))
      .filter(Boolean);
  } else {
    // Otherwise find pages with similar modes
    related = topicPages.filter((page) =>
      page.relatedModes?.some((mode) => currentPage.relatedModes?.includes(mode))
    );
  }

  return related.slice(0, limit);
};
